import { connect } from 'react-redux';
import { setToastError } from '../../sagas/routines/toastRoutines';
import FileSelector from '../../Components/Atoms/FileSelector/';

const mapDispatchToProps = {
    onError: setToastError,
};

export default connect(
    null,
    mapDispatchToProps,
)(FileSelector);
